import React from 'react';
import { Check } from 'lucide-react';

const BULLETS = [
  'Set unlimited price tiers with custom allocations',
  'See your blended cost basis and exit price live',
  'Visualise tier targets directly on the price chart',
];

const TIERS = [
  { n: 1, price: '$5.00',  pct: '40%', amount: '1,000 XRP', value: '$5,000',  color: '#d4b483' },
  { n: 2, price: '$9.00',  pct: '35%', amount: '875 XRP',   value: '$7,875',  color: '#6b95cf' },
  { n: 3, price: '$17.00', pct: '25%', amount: '625 XRP',   value: '$10,625', color: '#a86fb8' },
];

export function SplitBuySellSection() {
  return (
    <section
      className="px-6 py-24 relative"
      style={{
        borderTop: '0.5px solid rgba(255,255,255,0.06)',
        background:
          'linear-gradient(180deg, rgba(212,180,131,0.04), transparent 60%)',
      }}
    >
      <div className="max-w-5xl mx-auto grid grid-cols-1 md:grid-cols-5 gap-10 md:gap-12 items-center">
        {/* LEFT, 2/5 */}
        <div className="md:col-span-2">
          <div
            className="text-[11px] font-semibold tracking-[0.18em] mb-4"
            style={{ color: '#d4b483' }}
          >
            ENTRY &amp; EXIT PLANNING
          </div>
          <h2
            className="font-semibold"
            style={{
              color: '#f4f1ea',
              fontSize: 'clamp(26px, 4vw, 36px)',
              letterSpacing: '-0.02em',
              lineHeight: 1.15,
            }}
          >
            Split Buy &amp; Sell Planner.
          </h2>
          <p
            className="mt-4 text-[15px] leading-relaxed"
            style={{ color: 'rgba(244,241,234,0.6)' }}
          >
            Plan your entries and exits positions across multiple price tiers.
            Whether the market dips harder or rallies sooner, you're already
            positioned.
          </p>

          <ul className="mt-6 space-y-3">
            {BULLETS.map((b) => (
              <li key={b} className="flex items-start gap-3">
                <span
                  className="flex items-center justify-center rounded-full mt-0.5"
                  style={{
                    width: 18,
                    height: 18,
                    backgroundColor: 'rgba(212,180,131,0.15)',
                  }}
                >
                  <Check className="w-3 h-3" style={{ color: '#d4b483' }} strokeWidth={3} />
                </span>
                <span className="text-[14px]" style={{ color: 'rgba(244,241,234,0.8)' }}>
                  {b}
                </span>
              </li>
            ))}
          </ul>
        </div>

        {/* RIGHT, 3/5 */}
        <div className="md:col-span-3">
          <div
            className="rounded-xl"
            style={{
              backgroundColor: '#131313',
              border: '0.5px solid rgba(255,255,255,0.08)',
              padding: '18px',
            }}
          >
            <div
              className="text-[10px] tracking-[0.14em] mb-3"
              style={{ color: 'rgba(244,241,234,0.45)' }}
            >
              SPLIT SELL PLAN · XRP
            </div>

            {/* Allocation bar */}
            <div
              className="flex w-full overflow-hidden rounded-full"
              style={{ height: 6 }}
            >
              <div style={{ width: '40%', backgroundColor: '#d4b483' }} />
              <div style={{ width: '35%', backgroundColor: '#6b95cf' }} />
              <div style={{ width: '25%', backgroundColor: '#a86fb8' }} />
            </div>

            {/* Tier cards */}
            <div className="mt-4 space-y-2">
              {TIERS.map((t) => (
                <div
                  key={t.n}
                  className="flex items-center justify-between rounded-md"
                  style={{
                    backgroundColor: 'rgba(255,255,255,0.025)',
                    borderLeft: `2px solid ${t.color}`,
                    padding: '12px 14px',
                  }}
                >
                  <div className="text-[12px]" style={{ color: 'rgba(244,241,234,0.85)' }}>
                    Tier {t.n} · <span style={{ color: '#f4f1ea' }}>{t.price}</span> ·{' '}
                    <span style={{ color: 'rgba(244,241,234,0.55)' }}>{t.pct}</span>
                  </div>
                  <div className="text-[12px] text-right tabular-nums" style={{ color: 'rgba(244,241,234,0.65)' }}>
                    {t.amount} · <span style={{ color: '#f4f1ea' }}>{t.value}</span>
                  </div>
                </div>
              ))}
            </div>

            {/* Footer */}
            <div
              className="mt-4 pt-3 flex items-center justify-between"
              style={{ borderTop: '0.5px solid rgba(255,255,255,0.06)' }}
            >
              <span className="text-[12px]" style={{ color: 'rgba(244,241,234,0.55)' }}>
                Total profit
              </span>
              <span className="text-[13px] font-medium tabular-nums" style={{ color: '#6db981' }}>
                +$17,580
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
